import React from 'react';
import PropTypes from 'prop-types';

const defaultProps = {
  children: null,
};

const propTypes = {
  tagName: PropTypes.string.isRequired,
  children: PropTypes.node,
};

const HtmlElement = ({
  tagName,
  children,
  ...rest
}) => {
  const HtmlComponent = tagName;

  return (
    <HtmlComponent {...rest}>
      {children}
    </HtmlComponent>
  );
};

HtmlElement.defaultProps = defaultProps;
HtmlElement.propTypes = propTypes;

export default HtmlElement;
